//配置全局访问接口地址
// let commonUrl = "https://americanfilmmarket.vip"; //live
// let commonUrl = "http://localhost:8888"; //test
let commonUrl = "https://movieback.hk9999z.com/"; //test
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl